// import DevicesIcon from '@mui/icons-material/Devices';
// import DoorFrontIcon from '@mui/icons-material/DoorFront';
import InfoIcon from '@mui/icons-material/Info';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';

import {formatLeadStatus} from '../../helpers/leads';
import LeadIcon from './LeadIcon';
import SchedulePatientButton from '../patients/SchedulePatientButton';

const getStepTitle = (stepText) => {
  let stepNum = stepText.replace(/\/7\)$/, '').match(/\d$/)?.[0];
  if (!stepNum) return '';
  switch (stepNum) {
    case '1':
      return 'Created Account';
    case '2':
      return 'Selected Provider';
    case '3':
      return 'Picked Session Type';
    case '4':
      return 'Added Contact Info';
    case '5':
      return 'Signed Contract';
    case '6':
      return 'Submitted Payment Info';
    default:
      return '';
  }
};

const LeadStatus = ({ lead, includeStep = false, iconOnly = false }) => {
  if (!lead) return null;

  const statusText = formatLeadStatus(lead, { includeStep });

  return (
    <Stack direction='row' spacing={0.25} alignItems='center' style={{minWidth: '155px'}}>
      <LeadIcon status={lead.status} />
      {iconOnly ? null : 
        <span className="lead-status">
          {statusText}
        </span>
      }
      {
        iconOnly || lead.status !== 'CREATED_ACCOUNT' ? null :
        <Tooltip title={getStepTitle(statusText || '')} placement='bottom'>
          <InfoIcon color='muted' sx={{width: 14, height: 14, color: 'text.muted'}}/>
        </Tooltip>
      }
      {
        iconOnly || lead.status !== 'COMPLETED_SIGNUP' ? null : 
        <SchedulePatientButton iconOnly={true} patient={lead.patient} />
      }
    </Stack>
  );
};

export default LeadStatus;